import React, { useRef } from 'react';
import { Grid, Container, Typography, Button, Hidden } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';

import CurRoute from '../../../Components/CurRoute';
import ArticleParser from '../../../Components/ArticleParser/ArticleParser';
import data from '../../../Data/areas.data';
import { NavLink, useParams, Redirect } from 'react-router-dom';
import Divider from '../../../Components/Divider';
import { useStyle } from './useStyle';
import { Fragment } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

const AreaView = () => {
	const classes = useStyle();
	const { area } = useParams();
	const swiperRef = useRef(null);
	const findArea = data.find(item => item.path === `/${area}`);
	if (!findArea) return <Redirect to='/areas-of-law-practices' />;
	const curAreaIndex = data.indexOf(findArea);
	swiperRef.current && swiperRef.current.slideTo(curAreaIndex);

	const desktopHeader = (
		<Fragment>
			<Typography variant='h2'>Other Law Practices</Typography>
			<Divider className='divider' />
			{data.map((item, i) => (
				<NavLink
					key={i}
					activeClassName={classes.activeButton}
					to={'/areas-of-law-practices' + item.path}>
					<Button disableElevation className={classes.button} variant='outlined'>
						{item.name}
					</Button>
				</NavLink>
			))}
		</Fragment>
	);

	const breakPointes = {
		0: { slidesPerView: 1.5, spaceBetween: 10 },
	};
	const mobileHeader = (
		<Fragment>
			<Typography variant='h2'>Other Law Practices</Typography>
			<Divider className='divider' />
			<Swiper
				spaceBetween={10}
				className={classes.swiperContainer}
				breakpoints={breakPointes}
				onAfterInit={swiper => {
					swiper.slideTo(curAreaIndex);
					swiperRef.current = swiper;
				}}
				keyboard={{ enabled: true }}>
				{data.map((item, i) => (
					<SwiperSlide>
						<NavLink
							key={i}
							activeClassName={classes.activeButton}
							to={'/areas-of-law-practices' + item.path}>
							<Button
								endIcon={<CheckIcon />}
								disableElevation
								className={classes.button}
								variant='outlined'>
								{item.name}
							</Button>
						</NavLink>
					</SwiperSlide>
				))}
			</Swiper>
			<Typography variant='h2'>{findArea.name}</Typography>
			<Divider className='divider' />
		</Fragment>
	);

	return (
		<Container className={classes.container}>
			<Hidden smDown>
				<Typography variant='h2'>{findArea.name}</Typography>
			</Hidden>
			<CurRoute paddingLeft='0px' />
			<Grid className={classes.gridContainer} container>
				<Grid className={classes.leftGrid} xs={12} md={3}>
					<Hidden smDown>{desktopHeader}</Hidden>
					<Hidden smUp>{mobileHeader}</Hidden>
				</Grid>
				<Grid xs={12} md={9}>
					<Container maxWidth={false} className={classes.article}>
						<ArticleParser content={findArea.content} />
					</Container>
				</Grid>
			</Grid>
		</Container>
	);
};

export default AreaView;
